import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class DefaultConfirmationDialog extends React.PureComponent {

  static propTypes = {
    open: PropTypes.bool,
    type: PropTypes.oneOf(['info', 'danger']),
    icon: PropTypes.node,
    iconClass: PropTypes.string,
    title: PropTypes.node,
    message: PropTypes.node,
    disableButtons: PropTypes.bool,
    onClose: PropTypes.func,
    cancelLabel: PropTypes.string,
    onConfirm: PropTypes.func,
    confirmLabel: PropTypes.string,
    DialogProps: PropTypes.object
  }

  static defaultProps = {
    open: false,
    type: 'danger',
    icon: null,
    iconClass: null,
    title: null,
    message: null,
    cancelLabel: 'defaults.no',
    confirmLabel: 'defaults.yes',
    disableButtons: false,
    onClose: () => {},
    onConfirm: () => {},
    DialogProps: {}
  }

  render() {
    const {
      open,
      onClose,
      type,
      icon,
      title,
      message,
      disableButtons,
      cancelLabel,
      onConfirm,
      confirmLabel,
      DialogProps
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        {...DialogProps}
      >
        <DialogTitle className={`dialog-title dialog-title${type}`}>
          {!!icon && (
            <Icon className={this.props.iconClass}>{this.props.icon}</Icon>
          )}
          {title}
        </DialogTitle>

        <DialogContent className="dialog-content">
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            className="btn btn-secondary"
            disabled={disableButtons}
            onClick={onClose}
          >
            {I18n.t(cancelLabel, cancelLabel)}
          </Button>

          <Button
            className="btn btn-danger"
            disabled={disableButtons}
            onClick={onConfirm}
          >
            {I18n.t(confirmLabel, confirmLabel)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

}
